import { NavigationTabs, type NavigationTabItem } from '@exam-management/components';

const TAB_ITEMS: NavigationTabItem[] = [
  {
    value: 'details',
    label: 'Question Details',
    path: '/qbank-structures/:structureId/qcontents/item-set/:questionId',
  },
  {
    value: 'activity',
    label: 'Activity Log',
    path: '/qbank-structures/:structureId/qcontents/item-set/:questionId/activity-log',
  },
];

export default function ItemSetNavigationTabs() {
  return <NavigationTabs items={TAB_ITEMS} navigateOptions={{ replace: true }} />;
}
